import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../api/axios';

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/blogs/${slug}`)
      .then((res) => setBlog(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return <div className="py-20 text-center text-xs text-[#8A796C]">Loading article...</div>;
  }

  if (!blog) {
    return (
      <div className="max-w-md mx-auto my-20 p-8 bg-white border border-[#E8DFD8] rounded-2xl text-center space-y-4">
        <h2 className="font-heading text-xl font-bold text-[#2B1810]">Article Not Found</h2>
        <p className="text-xs text-[#8A796C]">The blog article you are looking for does not exist or has been removed.</p>
        <Link to="/blog" className="inline-block bg-[#C49A45] text-white text-xs font-bold px-6 py-2.5 rounded shadow">
          Back to Blog
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-[#FAF8F5] min-h-screen text-[#2B1810] py-12">
      <article className="max-w-4xl mx-auto px-4 space-y-8">
        {/* Navigation Link */}
        <Link to="/blog" className="inline-flex items-center gap-1.5 text-xs font-bold text-[#C49A45] hover:underline">
          ← Back to All Blog Articles
        </Link>

        {/* Article Header */}
        <div className="space-y-4">
          <span className="inline-block bg-[#C49A45]/20 text-[#C49A45] border border-[#C49A45]/40 text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full">
            {blog.category}
          </span>
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-[#2B1810] leading-tight">
            {blog.title}
          </h1>

          <div className="flex items-center gap-4 text-xs text-[#8A796C] border-b border-[#E8DFD8] pb-6">
            <span>By <strong className="text-[#2B1810]">{blog.author}</strong></span>
            <span>•</span>
            <span>{new Date(blog.createdAt).toLocaleDateString()}</span>
            <span>•</span>
            <span>{blog.viewsCount} Reads</span>
          </div>
        </div>

        {/* Feature Image */}
        <div className="rounded-2xl overflow-hidden shadow-xl border border-[#E8DFD8] max-h-[450px]">
          <img
            src={blog.image}
            alt={blog.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = '/assets/hero_perfect_ganesha.jpg';
            }}
          />
        </div>

        {/* Article Body */}
        <div
          className="prose prose-stone max-w-none text-sm leading-relaxed space-y-4 text-[#2B1810] bg-white p-8 md:p-12 rounded-2xl border border-[#E8DFD8] shadow-sm"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />

        {/* Tags Footer */}
        {blog.tags && blog.tags.length > 0 && (
          <div className="flex flex-wrap items-center gap-2 pt-4">
            <span className="text-xs font-bold text-[#8A796C]">Tags:</span>
            {blog.tags.map((t, idx) => (
              <span key={idx} className="bg-[#FAF8F5] border border-[#E8DFD8] text-[11px] font-bold text-[#2B1810] px-3 py-1 rounded-full">
                #{t}
              </span>
            ))}
          </div>
        )}
      </article>
    </div>
  );
}
